"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Persona_types_1 = require("./Persona.types");
// Persona Sizes
var personaSize;
(function (personaSize) {
    personaSize.size10 = '20px';
    personaSize.size16 = '16px';
    personaSize.size24 = '24px';
    personaSize.size28 = '28px';
    personaSize.size32 = '32px';
    personaSize.size40 = '40px';
    personaSize.size48 = '48px';
    personaSize.size72 = '72px';
    personaSize.size100 = '100px';
})(personaSize = exports.personaSize || (exports.personaSize = {}));
// Persona Presence Sizes
var personaPresenceSize;
(function (personaPresenceSize) {
    personaPresenceSize.size6 = '6px';
    personaPresenceSize.size8 = '8px';
    personaPresenceSize.size12 = '12px';
    personaPresenceSize.size20 = '20px';
    personaPresenceSize.size28 = '28px';
    /**
     * @deprecated This is now unused
     */
    personaPresenceSize.border = '2px';
})(personaPresenceSize = exports.personaPresenceSize || (exports.personaPresenceSize = {}));
exports.sizeBoolean = function (size) { return ({
    isSize10: size === Persona_types_1.PersonaSize.size10 || size === Persona_types_1.PersonaSize.tiny,
    isSize16: size === Persona_types_1.PersonaSize.size16,
    isSize24: size === Persona_types_1.PersonaSize.size24 || size === Persona_types_1.PersonaSize.extraExtraSmall,
    isSize28: size === Persona_types_1.PersonaSize.size28 || size === Persona_types_1.PersonaSize.extraSmall,
    isSize32: size === Persona_types_1.PersonaSize.size32,
    isSize40: size === Persona_types_1.PersonaSize.size40 || size === Persona_types_1.PersonaSize.small,
    isSize48: size === Persona_types_1.PersonaSize.size48 || size === Persona_types_1.PersonaSize.regular,
    isSize72: size === Persona_types_1.PersonaSize.size72 || size === Persona_types_1.PersonaSize.large,
    isSize100: size === Persona_types_1.PersonaSize.size100 || size === Persona_types_1.PersonaSize.extraLarge
}); };
exports.sizeToPixels = (_a = {},
    _a[Persona_types_1.PersonaSize.tiny] = 10,
    _a[Persona_types_1.PersonaSize.extraExtraSmall] = 24,
    _a[Persona_types_1.PersonaSize.extraSmall] = 28,
    _a[Persona_types_1.PersonaSize.small] = 40,
    _a[Persona_types_1.PersonaSize.regular] = 48,
    _a[Persona_types_1.PersonaSize.large] = 72,
    _a[Persona_types_1.PersonaSize.extraLarge] = 100,
    _a[Persona_types_1.PersonaSize.size10] = 10,
    _a[Persona_types_1.PersonaSize.size16] = 16,
    _a[Persona_types_1.PersonaSize.size24] = 24,
    _a[Persona_types_1.PersonaSize.size28] = 28,
    _a[Persona_types_1.PersonaSize.size32] = 32,
    _a[Persona_types_1.PersonaSize.size40] = 40,
    _a[Persona_types_1.PersonaSize.size48] = 48,
    _a[Persona_types_1.PersonaSize.size72] = 72,
    _a[Persona_types_1.PersonaSize.size100] = 100,
    _a);
exports.presenceBoolean = function (presence) { return ({
    isAvailable: presence === Persona_types_1.PersonaPresence.online,
    isAway: presence === Persona_types_1.PersonaPresence.away,
    isBlocked: presence === Persona_types_1.PersonaPresence.blocked,
    isBusy: presence === Persona_types_1.PersonaPresence.busy,
    isDoNotDisturb: presence === Persona_types_1.PersonaPresence.dnd,
    isOffline: presence === Persona_types_1.PersonaPresence.offline
}); };
var _a;
//# sourceMappingURL=PersonaConsts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Persona/PersonaConsts.js
// module id = 656
// module chunks = 0